export default {
	props: {
		widgetSelector: {
			required: true,
			type: String,
		},
		widgetId: {
			required: false,
			type: String,
		},
		widgetTrackingLocation: {
			required: true,
			type: String,
		},
	},
	mounted() {
		this.loadPromoWidget();
	},
	methods: {
		loadPromoWidget() {
			window.dataLayer = window.dataLayer || [];

			window.dataLayer.push({
				event: "loadPromoWidget",
				promoWidget: {
					id: this.widgetId, // The 'ad' identifier
					container: `.${this.widgetSelector}`, // Where the ad will load
					location: this.widgetTrackingLocation, // GA4 Tracking
				},
			});
		},
	},
};
